export const client = {
  address: {
    streetAddress1: 'test address 1',
    streetAddress2: 'test address 2',
    city: 'test city',
    postalCode: '00001',
    region: 'AK',
    country: 'USA',
  },
  alias: 'palmlanedev',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  logoImage: null,
  longDescription: 'This is the Test Client used in dev and QA testing.',
  medLogo: null,
  shortDescription: 'This is a Test Client in dev env',
  title: 'palmlanedev',
};
